import i18n from 'i18next';
import type { BackendModule, ReadCallback } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { fetchTranslations } from '../api/translationService';
import { loadLocale } from '../locales';

// Local bundle is the floor; BE `finder.*` overrides overlay on top, degrading to
// local-only on failure. Google Translate handles non-keyed dynamic BE data.
const localeBackend: BackendModule = {
  type: 'backend',
  init: () => {},
  read: (language: string, _namespace: string, callback: ReadCallback) => {
    loadLocale(language)
      .then(async (local) => {
        try {
          const overrides = await fetchTranslations(language);
          callback(null, { ...local, ...overrides });
        } catch {
          callback(null, local);
        }
      })
      .catch((err) => callback(err instanceof Error ? err : new Error('locale load failed'), false));
  },
};

i18n.use(localeBackend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    ns: ['finder'],
    defaultNS: 'finder',
    keySeparator: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    saveMissing: false,
  });

// Apply per-org languages; resolves once resources load so callers can gate on it.
export const initI18n = (languagesEnabled: string[]): Promise<unknown> => {
  const langs = languagesEnabled.length ? languagesEnabled : ['en'];
  const defaultLang = langs[0];
  i18n.options.fallbackLng = defaultLang;

  if (i18n.language !== defaultLang && !langs.includes(i18n.language)) {
    return i18n.changeLanguage(defaultLang);
  }
  return i18n.reloadResources();
};

export default i18n;
